import React, { useState, useEffect, useRef } from 'react';

import { useReactToPrint } from 'react-to-print';

import { APIROOT } from '../../Helpers/configs';
import { useLocation, useNavigate } from 'react-router-dom';
import { convertDate, defineTicketNumber } from '../../Helpers/helpers';

// import { convertDateBySlices } from '../../Helpers/dateHelpers';
import { GetAuth } from '../../Auth/AuthProvider';

import StockUsed from '../CommonComponents/StockUsed';

import JobCardCabinetDetails from './JobCardCabinetDetails';
import JobCardStockUsed from './JobCardStockUsed';
import JobCardSatisfaction from './JobCardSatisfaction';
import JobCardCustomerInfo from './JobCardCustomerInfo';
import JobCardGas from './JobCardGas';
import JobCardNotes from './JobCardNotes';
import JobCardFeedback from './JobCardFeedback';
import JobCardSignatures from './JobCardSignatures';

import { viewBox } from '../shared/commonStyle';
import Logo from '../shared/Logo';
import DocsLogo from '../shared/DocsLogo';

import { Box, Stack, Grid, Typography, Button } from '@mui/material/';

// import '../../Helpers/preventPrintBreak.css';
import '../../Helpers/print.css';

import './jc_print.css';

export default function JobCard() {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const location = useLocation();
  const customerName = location.state.customer_name;

  const [ticketData, setTicketData] = useState({});

  useEffect(() => {
    getTicketDatabyId(location.state.id).then((data) => {
      setTicketData(data.data.value);
    });
  }, [location.state]);

  useEffect(() => {
    let data = ticketData.jobcard;
    if (data === null || data === undefined || data === {}) {
      setJobcardInfo({
        order_number: null,

        grn_number: null,
        gas: {
          type: 'Not Used',
          in: 0,
          out: 0,
        },
        notes: '',
        stock_used: [],

        rating: null,
        feedback: null,
      });
    } else {
      setJobcardInfo(data);
      mapStockData(data);
    }
  }, [ticketData]);

  const mapStockData = async (data) => {
    let stock = [];
    try {
      stock = [...data.stock_used];
    } catch (error) {
      stock = [];
    }
    setRowsStockData(stock);
  };

  const mltsName = location.state.tech_assigned_name;

  const [jobcardInfo, setJobcardInfo] = useState({});

  const navigateNew = useNavigate();
  const [filteredSerialNumbersList, setFilteredSerialNumbersList] = useState();

  const [cabinetsList, setCabinetsList] = useState([]);
  // const [cabId, setCabId] = useState('');
  const [activeCab, setActiveCab] = useState({});

  const [cabinetType, setCabinetType] = useState([
    {
      id: activeCab.cabId,
      name: activeCab.cabType,
    },
  ]);
  // const [serialNumber, setSerialNumber] = useState({
  //   id: activeCab.serialId,
  //   name: activeCab.serialNo,
  // });

  useEffect(() => {
    let cabinet = cabinetType;
    // let cabinetTypes = [...cabinetsList];
    if (cabinet === undefined || cabinet === undefined || cabinet === []) {
      setCabinetsList([{ id: '1001', name: 'No Info' }]);
    } else {
      setCabinetsList((cabinetsList) => [...cabinetsList]);
    }
  }, [cabinetType]);

  useEffect(() => {
    serialsByCustomer(location.state.customer_name).then((data) => {
      mapAvailableSerials(data.data.value);
    });
  }, [location.state]);

  // const [cabinetTypes ]

  async function mapAvailableSerials(fullSerialList) {
    let cabinetsTypes;
    cabinetsTypes = fullSerialList.map((obj) => {
      return {
        id: obj.id,
        name: obj.serial_number,
      };
    });
    let distinctCabinetTypes;
    try {
      let cab = 'name';
      distinctCabinetTypes = [
        ...new Map(cabinetsTypes.map((obj) => [obj[cab], obj])).values(),
      ];
    } catch (error) {
      distinctCabinetTypes = [...cabinetsTypes];
    }
    setFilteredSerialNumbersList(distinctCabinetTypes);
  }

  const [stockList, setStockList] = useState([]);

  useEffect(() => {
    getStock('spares').then((data) => {
      setStockList(data.data.value);
    });
  }, []);

  const [gasList, setGasList] = useState([]);

  useEffect(() => {
    getStock('gas').then((data) => {
      setGasList(data.data.value);
    });
  }, []);

  const [orderNumber, setOrderNumber] = useState(null);

  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function
  const [forceUpdate, setForceUpdate] = useState(1);

  console.log(jobcardInfo);
  const [rowsCabData, setRowsCabData] = useState(
    jobcardInfo?.repair_ticket?.serial_numbers ?? []
  );
  const [rowsStockData, setRowsStockData] = useState(
    jobcardInfo.stock_used || []
  );

  const handleCabRowsChange = async (arr) => {
    const result = await addCabinet(arr);
    setRowsCabData(result);
  };

  const updateCabRow = (data) => {
    let oldData = [...rowsCabData];
    const newData = oldData.map((obj) => {
      console.log(obj);
      if (obj.id === data.id) {
        return {
          ...obj,
          id: data.id,
          cabId: data.cabId,
          cabType: data.cabType,
          serialId: data.serialId,
          serialNo: data.serialNo,
          description: data.description,
          exp: data.exp,
        };
      }

      return obj;
    });

    setRowsCabData(newData);
  };

  const removeCabRow = (data) => {
    let oldData = [...rowsCabData];
    // console.log(data);

    let tempData = oldData.slice().filter((item) => item.id !== data);

    setRowsCabData(tempData);
  };

  const [timeDat, setTimeDat] = useState('time');

  useEffect(() => {
    checkClock(location.state.id).then((data) => {
      // console.log(data.data.value.first_start_ts);
      setTimeDat(data.data.value.first_start_ts);
    });
  }, [location]);

  // useEffect(() => setRowsStockData(ticketData), [ticketData]);
  useEffect(() => setRowsCabData(location.state.serial_numbers), []);

  const handleRowsStockChange = async (arr) => {
    const result = await addStock(arr);
    setRowsStockData(result);
  };

  // useEffect(() => {
  //   setRowsStockData(jobcardInfo.stock_used);
  // }, [jobcardInfo]);

  const updateStockRow = (data, adjustmentType) => {
    let oldData = [...rowsStockData];

    // console.log('DATA', data, adjustmentType);
    const existingItems = oldData.filter((item) => {
      return item.id === data.id;
    });

    if (existingItems.length > 0) {
      data = { ...existingItems[0], qty: data.qty, rowId: data.id };
    }
    const newData = oldData.map((obj) => {
      if (obj.id === data.rowId) {
        return {
          ...obj,
          id: data.id,
          qty: data.qty,
          description: data.description,
          code: data.code,
        };
      }
      return obj;
    });

    // console.log('OUT BLOB', newData);
    setRowsStockData(newData);
  };

  const removeStockRow = (data) => {
    let oldData = [...rowsStockData];
    console.log(data);

    let tempData = oldData.slice().filter((item) => item.id !== data);

    setRowsStockData(tempData);
  };

  const combineData = () => {
    let stockItemsNoPlaceholders = rowsStockData.filter((item) => {
      return (
        item.description.toLowerCase() !== 'select description' &&
        item.code.toLowerCase() !== 'select stock code'
      );
    });

    let cabinetTypesNoPlaceholders = rowsCabData.filter((item) => {
      return (
        item.cabType.toLowerCase() !== 'add type' &&
        item.serialNo.toLowerCase() !== 'add serial no'
      );
    });
    setRowsCabData(cabinetTypesNoPlaceholders);

    console.log(rowsCabData);
    let ticketBlob = {
      repair_ticket: {
        serial_numbers: cabinetTypesNoPlaceholders
          ? cabinetTypesNoPlaceholders
          : rowsCabData,
      },
      jobcard: {
        order_number: jobcardInfo.order_number,
        grn_number: jobcardInfo.grn_number,
        stock_used: stockItemsNoPlaceholders
          ? stockItemsNoPlaceholders
          : rowsStockData,
        gas_type: jobcardInfo.gas_type,
        gas_in: jobcardInfo.gas_in,
        gas_out: jobcardInfo.gas_out,
        gas_used: jobcardInfo.gas_used,
        notes: jobcardInfo.notes,
        feedback: jobcardInfo.feedback,
        satisfaction: jobcardInfo.satisfaction,
        customer_name: jobcardInfo.customer_name,
      },
    };

    return ticketBlob;
  };

  const ticketUpdate = () => {
    // Validate gas
    console.log(
      jobcardInfo.gas_in,
      jobcardInfo.gas_out,
      parseFloat(jobcardInfo.gas_in) - parseFloat(jobcardInfo.gas_out)
    );
    if (
      (jobcardInfo.gas_type === undefined &&
        parseFloat(jobcardInfo?.gas_in ?? '0') -
          parseFloat(jobcardInfo?.gas_out ?? '0') >
          0) ||
      (jobcardInfo.gas_type === null &&
        parseFloat(jobcardInfo?.gas_in ?? '0') -
          parseFloat(jobcardInfo?.gas_out ?? '0') >
          0)
    ) {
      enqNotification(
        'Gas type needs to be selected if gas used is larger than zero',
        'error'
      );
      return;
    } else if (jobcardInfo.gas_in - jobcardInfo.gas_out < 0) {
      enqNotification('Gas used cannot be a negative value', 'error');
      return;
    } else {
      const DataBlob = { ...combineData() };
      // console.log('DATA BLOB', DataBlob);
      //Get JWT from storage
      let JWT = localStorage.getItem('JWT_Key');
      //Set default Headers
      let headers = {
        'content-type': 'application/JSON',
      };
      //Set JWT in header if available
      if (JWT) {
        headers['x-api-key'] = JWT;
      }
      let body = {};
      body = DataBlob;
      const request = new Request(
        `${APIROOT}/api/r2_repair_tickets/${location.state.id}`,
        {
          method: 'post',
          headers,
          body: JSON.stringify(body),
        }
      );
      fetch(request)
        .then((response) => {
          if (response.status === 200) {
            return response.text();
          } else {
            throw new Error(`Failed to save ticket`);
          }
        })
        .then((data) => {
          let parsed = JSON.parse(data);
          if (parsed.success === true) {
            setForceUpdate((val) => val + 1);
            //Update JWT if required
            // console.log(
            //   'here with path',
            //   `${APIROOT}/api/repair-tickets/${location.state.id}`
            // );
            if (parsed.JWT) {
              localStorage.setItem('JWT_Key', parsed.JWT);
            }
            navigateNew(`/tech/tech_ticket_view/jobcard`, {
              replace: true,
              state: location.state,
            });
            enqNotification('Saved successfully', 'success');
          } else {
            //Force logout
            if (parsed.message === 'Please login') {
              logout(() => {
                enqNotification('Session Expired', 'warning');
              });
            } else {
              enqNotification(parsed.message, 'error');
            }
          }
        })
        .catch((error) => {
          enqNotification(
            typeof error == 'string' ? error : `Connection Error !! ${error}`,
            'error'
          );
        });
    }
  };

  return (
    <Box sx={viewBox}>
      <Stack spacing={2} ref={componentRef} className='main-style'>
        <Grid
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
        >
          {/* <Grid item xs={12} md={12}>
            <Logo />
          </Grid>
          <Grid item xs={12} md={4} style={{ textAlign: 'center' }}></Grid>
          <Grid item xs={12} md={4} style={{ textAlign: 'center' }}>
            <Typography variant='h6' fontWeight='700' fontSize={22}>
              JOB CARD
            </Typography>
          </Grid>
          <Grid item xs={12} md={4} style={{ textAlign: 'center' }}>
            <Typography variant='h6' fontWeight='700' fontSize={22}>
              TICKET NR:{' '}
              {defineTicketNumber('repair', location.state.id, 5, 'R')}
            </Typography>
          </Grid> */}

          <Grid
            container
            direction='row'
            justify='flex-end'
            alignItems='center'
            className='justify_print'
          >
            <Grid item xs={12} md={4} style={{ textAlign: 'left' }}>
              <Typography
                variant='h6'
                fontWeight='700'
                fontSize={28}
                paddingLeft={'5px'}
                className='justify_print'
              >
                TICKET NR:{' '}
                {defineTicketNumber('repair', location.state.id, 5, 'R')}
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              style={{ textAlign: 'center' }}
              className='justify_print'
            >
              <Typography
                variant='h6'
                fontWeight='700'
                fontSize={28}
                className='justify_print'
              >
                JOB CARD
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <DocsLogo className='justify_logo_print' />
            </Grid>
          </Grid>

          <Grid
            container
            margin={0}
            rowSpacing={0}
            columnSpacing={{ xs: 2 }}
            rowGap={0}
            style={{ border: '1 solid black', margin: 0 }}
          >
            <JobCardCustomerInfo
              // timeData={timeDat}
              jobcardInfo={jobcardInfo}
              // orderNo={jobcardInfo.order_number}
              // grnNo={jobcardInfo.grn_number}
              customerData={location.state}
              setJobcardInfo={(id, value) =>
                setJobcardInfo({ ...jobcardInfo, [id]: value })
              }
            />
            <Grid
              item
              border={'grey solid 1px'}
              xs={12}
              md={12}
              style={{ textAlign: 'left', border: 'none', padding: 0 }}
            >
              <Typography
                variant='h6'
                fontWeight='700'
                style={{ fontWeight: '700' }}
              >
                Reported Problem:
              </Typography>
            </Grid>
            <Grid
              item
              border={'grey solid 1px'}
              md={12}
              xs={12}
              style={{ textAlign: 'left' }}
            >
              <Typography fontWeight='600' variant='subtitle1'>
                {location.state.description}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          className='p-print-avoid-break'
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
        >
          <Grid item xs={6} md={6} style={{ textAlign: 'left' }}>
            <Typography variant='h6' fontWeight='700'>
              Cabinet Details
            </Typography>
          </Grid>
          <Grid item xs={6} md={6} style={{ textAlign: 'left' }}>
            <Button
              className='d-print-none'
              variant='outlined'
              sx={{ float: 'right', fontWeight: '700' }}
              onClick={() => handleCabRowsChange(rowsCabData)}
            >
              Add Cabinet
            </Button>
          </Grid>
          <JobCardCabinetDetails
            updateCabRow={(data) => updateCabRow(data)}
            removeCabRow={(data) => removeCabRow(data)}
            customerName={customerName}
            rowsData={rowsCabData}
          />
        </Grid>
        <Grid
          className='p-print-avoid-break'
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
        >
          <Grid item xs={6} md={6} style={{ textAlign: 'left' }}>
            <Typography variant='h6' fontWeight='700'>
              Stock/Material Used
            </Typography>
          </Grid>
          <Grid item xs={6} md={6} style={{ textAlign: 'left' }}>
            <Button
              className='d-print-none'
              variant='outlined'
              sx={{ float: 'right', fontWeight: '700' }}
              onClick={() => handleRowsStockChange(rowsStockData)}
            >
              Add Stock Item
            </Button>
          </Grid>
          <StockUsed
            updateStockRow={(data, adjustmentType) =>
              updateStockRow(data, adjustmentType)
            }
            removeStockRow={(data) => removeStockRow(data)}
            rowsStockData={rowsStockData}
          />
          <JobCardGas
            gasList={gasList}
            gasValues={jobcardInfo}
            setGasType={(data) =>
              setJobcardInfo({ ...jobcardInfo, gas_type: data })
            }
            setGasIn={(data) =>
              setJobcardInfo({ ...jobcardInfo, gas_in: data })
            }
            setGasOut={(data) =>
              setJobcardInfo({ ...jobcardInfo, gas_out: data })
            }
            setCalcGasUsed={(data) =>
              setJobcardInfo({ ...jobcardInfo, gas_used: data })
            }
          />

          <JobCardNotes
            className='p-print-avoid-break'
            // notesType='Notes:'
            notesInfo={jobcardInfo}
            setNotes={(data) => setJobcardInfo({ ...jobcardInfo, notes: data })}
          />
        </Grid>
        <Grid
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
          className='no-print-break p-print-avoid-break'
        >
          <Grid item xs={12} md={12} style={{ textAlign: 'center' }}>
            <Typography variant='h6' fontWeight='700'>
              CUSTOMER SATISFACTION
            </Typography>
          </Grid>
          <JobCardSatisfaction
            emojiInfo={jobcardInfo}
            setEmoji={(data) =>
              setJobcardInfo({ ...jobcardInfo, satisfaction: data })
            }
          />
          <JobCardFeedback
            // className='p-print-avoid-break'
            feedbackInfo={jobcardInfo}
            setFeedback={(data) =>
              setJobcardInfo({ ...jobcardInfo, feedback: data })
            }
          />
        </Grid>
        <Grid
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
          // className='no-print-break p-print-avoid-break'
          className='no-print-break p-print-avoid-break'
        >
          <JobCardSignatures
            mltsEmployee={mltsName}
            // className='p-print-avoid-break'
          />
        </Grid>
      </Stack>
      <Box sx={{ float: 'right' }}>
        <Button
          variant='contained'
          onClick={() => {
            ticketUpdate();
          }}
          sx={{ margin: '15px 0 0 15px' }}
        >
          Save
        </Button>
        <Button
          variant='contained'
          sx={{ margin: '15px 0 0 15px' }}
          onClick={handlePrint}
        >
          Print
        </Button>

        <Button
          onClick={() =>
            navigateNew(`/tech/tech_repair_ticket_view`, {
              replace: true,
              state: location.state,
            })
          }
          variant='contained'
          sx={{ margin: '15px 0 0 15px' }}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
}

//FUNCTIONS
async function serialsByCustomer(customerName, cabinetType) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {
    pagereq: {
      filter: {
        fullfilter: [
          {
            field: 'store_name',
            search: customerName,
            strict: true,
          },
          // {
          //   field: 'cabinet_type_id',
          //   search: cabinetType,
          //   strict: true,
          // },
        ],
      },
    },
  };
  const request = new Request(`${APIROOT}/api/serialnumbers`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}

//STOCK
async function getStock(type) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {
    pagereq: {
      filter: {
        fullfilter: [
          {
            field: 'type',
            search: type,
            strict: true,
          },
        ],
      },
    },
  };

  const request = new Request(`${APIROOT}/api/consumables`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}

//TICKET DATA
async function getTicketDatabyId(TicketId) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {};

  const request = new Request(`${APIROOT}/api/repair-tickets/${TicketId}`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}

const addCabinet = (data) => {
  let rowId = data.length + 1;
  let newObj = [
    {
      id: rowId,
      cabType: 'add type',
      serialNo: 'add Serial No',
      description: '',
      exp: '',
    },
  ];
  let newData = [...data, ...newObj];
  return new Promise((resolve) => {
    resolve(newData);
  });
};

const addStock = (data) => {
  let rowId = data.length + 1;
  let newObj = [
    {
      id: rowId,
      qty: '1',
      description: 'select description',
      code: 'select stock code',
    },
  ];
  let newData = [...data, ...newObj];
  return new Promise((resolve) => {
    resolve(newData);
  });
};

const removeStock = (data) => {
  let rowId = data.length + 1;
  let newObj = [
    {
      id: rowId,
      qty: '1',
      description: 'select description',
      code: 'select stock code',
    },
  ];
  let newData = [...data, ...newObj];
  return new Promise((resolve) => {
    resolve(newData);
  });
};

async function checkClock(ticketId) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };
  if (JWT) {
    headers['x-api-key'] = JWT;
  }
  let body = {
    fetch: 'ticket_hours_repair',
    fetchid: ticketId,
  };
  const request = new Request(`${APIROOT}/api/actions`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });
  const response = await fetch(request);

  const data = response.json();
  return data;
}
